import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  signedUp: false,
  errorMsg: null,
};

const signupSlice = createSlice({
  name: "signup",
  initialState,
  reducers: {
    signupSuccess: (state) => {
      state.signedUp = true;
    },
    signupError: (state, { payload }) => {
      state.errorMsg = payload;
    },
  },
});

export const { signupSuccess, signupError } = signupSlice.actions;

export default signupSlice.reducer;
